<template>
  <div>
    <div class="display-ticket">
      <span class="display-ticket-letter">{{ letter }}</span>
      <span class="display-ticket-number">{{ number | padWithZeros(3) }}</span>
    </div>
    <div class="display-table">
      {{ desk }}
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  filters: {
    padWithZeros (value) {
      return String(value).padStart(3, '0')
    }
  },
  props: {
    letter: {
      type: String,
      required: true
    },
    desk: {
      type: Number,
      default: null
    },
    number: {
      type: Number,
      required: true
    }
  },
  methods: {
    ...mapActions([
      'fetchCurrentTickets'
    ])
  }
}
</script>
<style lang="scss" scoped>
.display-queue {
  margin-bottom: 80px;
  display: flex;
  align-items: center;
}

.display-ticket,
.display-table {
  border-radius: 2px;
  transition: all 0.3s ease;
  text-transform: uppercase;
}

.display-ticket {
  width: 270px;
  background-color: #140a2b;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 10px 0 7px;
}

.display-table {
  text-align: center;
  width: 20rem;
  margin-left: 6rem;
}

.display-ticket-letter {
  margin-left: 26px;
  margin-right: 16px;
  width: 60px;
  text-align: center;
  display: inline-block;
}

.display-table-label,
.display-table {
  width: 200px;
}

.queue.first-call .display-ticket {
  background-color: #009de0;
  animation: 1s ease 3s 1 forwards ticket, 1.2s ease 0.1s 1 flash;
}

.queue.calling-again .display-ticket {
  background-color: #eb0036;
  animation: 1s ease 3s 1 forwards ticket, 1.2s ease 0.1s 1 flash;
}

.queue.first-call .display-table {
  color: #009de0;
  animation-duration: 1s;
  animation-timing-function: ease;
  animation-delay: 3s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-name: table;
}

.queue.calling-again .display-table {
  color: #eb0036;
  animation-duration: 1s;
  animation-timing-function: ease;
  animation-delay: 3s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-name: table;
}
</style>
